export const URL_Doctor = (`${process.env.REACT_APP_HOST}/doctor`)
export const URL_DoctorClinic = (`${process.env.REACT_APP_HOST}/doctorclinic`)
export const URL_Commission = (`${process.env.REACT_APP_HOST}/commission`)
export const URL_ProfessionalProfile = (`${process.env.REACT_APP_HOST}/professionalprofile`)



